import { USStateOptions } from '@strata/constants';
import { Button } from '@strata/react-buttons';
import { TextInputFormik } from '@strata/react-inputs';
import { SuggestSingleSelectFormik } from '@strata/react-selects';
import { useFormikContext } from 'formik';

export const PayToInformationFields = () => {
    const formik = useFormikContext();

    return (
        <>
            <div className="margin__bottom--medium font-bold--uppercase">Pay To Information</div>
            <Button
                className="margin__bottom--medium"
                label="Copy Organization Address"
                onClick={() =>
                    formik.setValues({
                        ...formik.values,
                        payto_address_1: formik.values.address_1,
                        payto_address_2: formik.values.address_2,
                        payto_city: formik.values.city,
                        payto_state: formik.values.state,
                        payto_postal_code: formik.values.postal_code,
                    })
                }
            />
            <TextInputFormik label="Pay To Address Line 1" id="payto_address_1" required />
            <TextInputFormik label="Pay To Address Line 2" id="payto_address_2" />
            <TextInputFormik label="Pay To City" id="payto_city" required />
            <SuggestSingleSelectFormik
                label="Pay To State"
                id="payto_state"
                required
                values={USStateOptions}
                selectedItem={USStateOptions.find(
                    ({ secondaryData }) => secondaryData === formik.values.payto_state,
                )}
                onChange={(newVal) => formik.setFieldValue('payto_state', newVal?.secondaryData)}
            />
            <TextInputFormik label="Pay To Postal Code" id="payto_postal_code" required />
        </>
    );
};
